var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfettiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 117,
    viewBox: "0 0 213 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9408 86.6638C47.1611 86.6638 44.0811 83.2411 44.0811 79.0409C44.0811 74.8407 47.1611 71.418 50.9408 71.418C54.7206 71.418 57.8006 74.8407 57.8006 79.0409C57.8006 83.2411 54.7206 86.6638 50.9408 86.6638ZM50.9408 73.7049C48.293 73.7049 46.139 76.0985 46.139 79.0409C46.139 81.9834 48.293 84.377 50.9408 84.377C53.5887 84.377 55.7427 81.9834 55.7427 79.0409C55.7427 76.0985 53.5887 73.7049 50.9408 73.7049Z",
    fill: "#E7B92A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.668 44.6857C198.344 44.6857 197.267 43.4889 197.267 42.0176C197.267 40.5464 198.344 39.3496 199.668 39.3496C200.991 39.3496 202.068 40.5464 202.068 42.0176C202.068 43.4889 200.991 44.6857 199.668 44.6857ZM199.668 40.1119C198.721 40.1119 197.953 40.9657 197.953 42.0176C197.953 43.0696 198.721 43.9234 199.668 43.9234C200.614 43.9234 201.382 43.0696 201.382 42.0176C201.382 40.9657 200.614 40.1119 199.668 40.1119Z",
    fill: "#FFEB97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3052 114.802C72.7549 114.802 71.4927 113.399 71.4927 111.676C71.4927 109.953 72.7549 108.551 74.3052 108.551C75.8555 108.551 77.1177 109.953 77.1177 111.676C77.1177 113.399 75.8555 114.802 74.3052 114.802ZM74.3052 109.466C73.2076 109.466 72.3158 110.457 72.3158 111.676C72.3158 112.896 73.2076 113.887 74.3052 113.887C75.4027 113.887 76.2945 112.896 76.2945 111.676C76.2945 110.457 75.4027 109.466 74.3052 109.466Z",
    fill: "url(#paint0_linear_28520_30051)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.34 76.5188C175.044 76.5188 176.426 74.983 176.426 73.0885C176.426 71.194 175.044 69.6582 173.34 69.6582C171.635 69.6582 170.253 71.194 170.253 73.0885C170.253 74.983 171.635 76.5188 173.34 76.5188Z",
    fill: "#E7B92A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5557 37.4142C46.8817 37.4142 47.9566 36.2197 47.9566 34.7462C47.9566 33.2726 46.8817 32.0781 45.5557 32.0781C44.2297 32.0781 43.1548 33.2726 43.1548 34.7462C43.1548 36.2197 44.2297 37.4142 45.5557 37.4142Z",
    fill: "#E7B92A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.721 21.2683C151.237 21.2683 152.465 19.9031 152.465 18.2191C152.465 16.5351 151.237 15.1699 149.721 15.1699C148.206 15.1699 146.978 16.5351 146.978 18.2191C146.978 19.9031 148.206 21.2683 149.721 21.2683Z",
    fill: "#FFD522"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38258 98.03C9.898 98.03 11.1265 96.6648 11.1265 94.9808C11.1265 93.2968 9.898 91.9316 8.38258 91.9316C6.86716 91.9316 5.63867 93.2968 5.63867 94.9808C5.63867 96.6648 6.86716 98.03 8.38258 98.03Z",
    fill: "#FFD522"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.478 103.123C202.615 103.123 203.536 102.099 203.536 100.836C203.536 99.5727 202.615 98.5488 201.478 98.5488C200.342 98.5488 199.42 99.5727 199.42 100.836C199.42 102.099 200.342 103.123 201.478 103.123Z",
    fill: "#FFD522"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8699 66.1673C64.5747 66.1673 65.9568 64.6315 65.9568 62.737C65.9568 60.8424 64.5747 59.3066 62.8699 59.3066C61.165 59.3066 59.783 60.8424 59.783 62.737C59.783 64.6315 61.165 66.1673 62.8699 66.1673Z",
    fill: "#1CCF9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.44 2.28688C132.008 2.28688 132.469 1.77495 132.469 1.14344C132.469 0.511936 132.008 0 131.44 0C130.872 0 130.411 0.511936 130.411 1.14344C130.411 1.77495 130.872 2.28688 131.44 2.28688Z",
    fill: "#1CCF9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6303 88.7927C23.1986 88.7927 23.6593 88.2808 23.6593 87.6493C23.6593 87.0178 23.1986 86.5059 22.6303 86.5059C22.062 86.5059 21.6013 87.0178 21.6013 87.6493C21.6013 88.2808 22.062 88.7927 22.6303 88.7927Z",
    fill: "#1CCF9E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9042 81.7107C72.4725 81.7107 72.9332 81.1988 72.9332 80.5673C72.9332 79.9358 72.4725 79.4238 71.9042 79.4238C71.3359 79.4238 70.8752 79.9358 70.8752 80.5673C70.8752 81.1988 71.3359 81.7107 71.9042 81.7107Z",
    fill: "#1CCF9E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.815 69.1091C153.384 69.1091 153.844 68.5972 153.844 67.9657C153.844 67.3342 153.384 66.8223 152.815 66.8223C152.247 66.8223 151.786 67.3342 151.786 67.9657C151.786 68.5972 152.247 69.1091 152.815 69.1091Z",
    fill: "#E7B92A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9071 9.10133C74.4754 9.10133 74.9361 8.5894 74.9361 7.95789C74.9361 7.32639 74.4754 6.81445 73.9071 6.81445C73.3389 6.81445 72.8782 7.32639 72.8782 7.95789C72.8782 8.5894 73.3389 9.10133 73.9071 9.10133Z",
    fill: "#FFC91F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.883 17.7919C112.83 17.7919 113.598 16.9387 113.598 15.8862C113.598 14.8337 112.83 13.9805 111.883 13.9805C110.936 13.9805 110.168 14.8337 110.168 15.8862C110.168 16.9387 110.936 17.7919 111.883 17.7919Z",
    fill: "#1CCF9E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208.805 84.3779C209.752 84.3779 210.52 83.5246 210.52 82.4721C210.52 81.4196 209.752 80.5664 208.805 80.5664C207.858 80.5664 207.09 81.4196 207.09 82.4721C207.09 83.5246 207.858 84.3779 208.805 84.3779Z",
    fill: "#1CCF9E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.882 60.6181C165.829 60.6181 166.597 59.7649 166.597 58.7124C166.597 57.6599 165.829 56.8066 164.882 56.8066C163.935 56.8066 163.167 57.6599 163.167 58.7124C163.167 59.7649 163.935 60.6181 164.882 60.6181Z",
    fill: "#1CCF9E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.329 102.437L177.325 94.2961L170.184 98.6107L169.203 96.6059L177.723 91.4452L184.418 99.2282L195.538 87.748L196.937 89.4251L184.329 102.437Z",
    fill: "#E7B92A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M174.67 43.2288L173.758 31.9392L183.869 31.924L180.762 19.7502L192.375 19.0107L189.213 10.0233L191.772 8.91797L196.306 21.8084L184.336 22.5783L187.498 34.9732L176.763 34.9884L177.401 42.9544L174.67 43.2288Z",
    fill: "#1CCF9E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1169 39.669L61.155 38.9601L64.5986 27.1445L55.1938 22.5403L59.1794 11.4718L47.9568 8.39973L48.4438 6.17383L61.9644 9.87858L57.8417 21.3359L67.1299 25.8867L63.1169 39.669Z",
    fill: "#E7B92A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0092 72.4181L9.32929 59.1237L2.26373 70.581L0 68.8582L9.7546 53.0254L15.7432 67.0211L22.0405 59.4134L27.7821 70.0093L25.4292 71.5796L21.5809 64.475L15.0092 72.4181Z",
    fill: "#FFE669"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5259 40.7896C24.503 36.3531 26.4512 27.2208 26.5335 26.832L28.5297 27.3809C28.5091 27.4571 26.8559 35.3469 31.6578 38.8839L30.5191 40.7896H30.5259Z",
    fill: "#E7B92A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M202.363 66.4407L200.587 65.2896C204.229 58.3527 212.55 59.9993 212.9 60.0679L212.523 62.3166C212.447 62.3014 205.272 60.9064 202.363 66.4407Z",
    fill: "#E7B92A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2174 101.134L55.2898 100.341C55.3172 100.265 58.0474 92.4213 66.4026 93.4199L66.1831 95.6915C59.3988 94.8835 57.2448 101.073 57.2243 101.134H57.2174Z",
    fill: "#E7B92A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M152.102 116.297L150.195 115.443C151.059 113.057 151.141 110.991 150.428 109.299C149.358 106.753 146.875 105.823 146.847 105.815L147.485 103.643C147.622 103.688 150.853 104.893 152.294 108.338C153.254 110.633 153.192 113.308 152.102 116.304V116.297Z",
    fill: "url(#paint1_linear_28520_30051)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7188 17.6638L79.731 15.6589C81.7546 14.424 82.9893 12.8842 83.4078 11.0852C84.032 8.37901 82.6326 5.87107 82.6189 5.8482L84.3544 4.61328C84.4299 4.75049 86.2477 7.95213 85.4109 11.6264C84.8483 14.0733 83.2775 16.1087 80.7256 17.6638H80.7188Z",
    fill: "url(#paint2_linear_28520_30051)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M166.857 89.6834C158.084 87.8387 155.984 78.9122 155.902 78.5311L157.898 77.9822L156.897 78.2567L157.898 77.9746C157.974 78.2948 159.785 85.872 167.241 87.4347L166.857 89.6834Z",
    fill: "#1CCF9E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M153.131 31.0318C151.978 31.9008 165.053 29.9112 170.857 12.6148C171.337 11.1893 165.376 6.48595 163.921 8.41456C162.474 10.3355 166.651 20.8552 153.131 31.0318Z",
    fill: "#E7B92A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28520_30051",
    x1: 74.3046,
    y1: 108.717,
    x2: 74.2527,
    y2: 116.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28520_30051",
    x1: 149.908,
    y1: 103.98,
    x2: 149.712,
    y2: 119.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28520_30051",
    x1: 82.6802,
    y1: 4.96123,
    x2: 82.4645,
    y2: 21.1804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338C71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiIcon);
export default __webpack_public_path__ + "static/media/confetti_icon.bddfeb74b9f6742a50c340a805b92514.svg";
export { ForwardRef as ReactComponent };